/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * MyYoast
 * The MyYoast Api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddSubscriptionDto,
  GetManyPagedSitesParams,
  GetManySitesParams,
  GetOneSiteParams,
  IndexSiteDto,
  RemoveSubscriptionResponseDto,
  Site,
  SwitchSubscriptionNumberOfTimesDto,
  TransferSiteDto,
  UnspecifiedResponseDto,
  UpdateSiteDto,
  UpdateSiteUrlDto
} from '../models';

import { customFetch } from '../../customFetch';
import type { ErrorType } from '../../customFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAddSubscriptionUrl = (id: string,) => {




  return `/api/Sites/${id}/subscriptions`
}

/**
 * @summary Adds a subscription to a site
 */
export const addSubscription = async (id: string,
    addSubscriptionDto: AddSubscriptionDto, options?: RequestInit): Promise<Site> => {

  return customFetch<Site>(getAddSubscriptionUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addSubscriptionDto)
  }
);}




export const getAddSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSubscription>>, TError,{id: string;data: AddSubscriptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addSubscription>>, TError,{id: string;data: AddSubscriptionDto}, TContext> => {

const mutationKey = ['addSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSubscription>>, {id: string;data: AddSubscriptionDto}> = (props) => {
          const {id,data} = props ?? {};

          return  addSubscription(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof addSubscription>>>
    export type AddSubscriptionMutationBody = AddSubscriptionDto
    export type AddSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Adds a subscription to a site
 */
export const useAddSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSubscription>>, TError,{id: string;data: AddSubscriptionDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addSubscription>>,
        TError,
        {id: string;data: AddSubscriptionDto},
        TContext
      > => {
      return useMutation(getAddSubscriptionMutationOptions(options), queryClient);
    }
    export const getRemoveSubscriptionUrl = (id: string,
    subscriptionId: string,) => {




  return `/api/Sites/${id}/subscriptions/${subscriptionId}`
}

/**
 * @summary Removes a subscription from a site
 */
export const removeSubscription = async (id: string,
    subscriptionId: string, options?: RequestInit): Promise<RemoveSubscriptionResponseDto> => {

  return customFetch<RemoveSubscriptionResponseDto>(getRemoveSubscriptionUrl(id,subscriptionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSubscription>>, TError,{id: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeSubscription>>, TError,{id: string;subscriptionId: string}, TContext> => {

const mutationKey = ['removeSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeSubscription>>, {id: string;subscriptionId: string}> = (props) => {
          const {id,subscriptionId} = props ?? {};

          return  removeSubscription(id,subscriptionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof removeSubscription>>>

    export type RemoveSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Removes a subscription from a site
 */
export const useRemoveSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSubscription>>, TError,{id: string;subscriptionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeSubscription>>,
        TError,
        {id: string;subscriptionId: string},
        TContext
      > => {
      return useMutation(getRemoveSubscriptionMutationOptions(options), queryClient);
    }
    export const getIndexUrl = () => {




  return `/api/Sites/index`
}

export const index = async (indexSiteDto: IndexSiteDto, options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getIndexUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(indexSiteDto)
  }
);}




export const getIndexMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof index>>, TError,{data: IndexSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof index>>, TError,{data: IndexSiteDto}, TContext> => {

const mutationKey = ['index'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof index>>, {data: IndexSiteDto}> = (props) => {
          const {data} = props ?? {};

          return  index(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IndexMutationResult = NonNullable<Awaited<ReturnType<typeof index>>>
    export type IndexMutationBody = IndexSiteDto
    export type IndexMutationError = ErrorType<void>

    export const useIndex = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof index>>, TError,{data: IndexSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof index>>,
        TError,
        {data: IndexSiteDto},
        TContext
      > => {
      return useMutation(getIndexMutationOptions(options), queryClient);
    }
    export const getCurrentSiteUrl = () => {




  return `/api/Sites/current`
}

/**
 * @summary Get the current connected site for an access token.
 */
export const currentSite = async ( options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getCurrentSiteUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCurrentSiteQueryKey = () => {
    return [
    `/api/Sites/current`
    ] as const;
    }


export const getCurrentSiteQueryOptions = <TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentSiteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentSite>>> = ({ signal }) => currentSite({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentSiteQueryResult = NonNullable<Awaited<ReturnType<typeof currentSite>>>
export type CurrentSiteQueryError = ErrorType<void>


export function useCurrentSite<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentSite>>,
          TError,
          Awaited<ReturnType<typeof currentSite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentSite<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentSite>>,
          TError,
          Awaited<ReturnType<typeof currentSite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentSite<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current connected site for an access token.
 */

export function useCurrentSite<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentSiteQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentSiteSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentSiteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentSite>>> = ({ signal }) => currentSite({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentSiteSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof currentSite>>>
export type CurrentSiteSuspenseQueryError = ErrorType<void>


export function useCurrentSiteSuspense<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentSiteSuspense<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentSiteSuspense<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current connected site for an access token.
 */

export function useCurrentSiteSuspense<TData = Awaited<ReturnType<typeof currentSite>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentSiteSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentCloneUrl = () => {




  return `/api/Sites/info`
}

/**
 * @summary Get the current connected site for a URL.
 */
export const currentClone = async ( options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getCurrentCloneUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCurrentCloneQueryKey = () => {
    return [
    `/api/Sites/info`
    ] as const;
    }


export const getCurrentCloneQueryOptions = <TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentCloneQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentClone>>> = ({ signal }) => currentClone({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentCloneQueryResult = NonNullable<Awaited<ReturnType<typeof currentClone>>>
export type CurrentCloneQueryError = ErrorType<void>


export function useCurrentClone<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentClone>>,
          TError,
          Awaited<ReturnType<typeof currentClone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentClone<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentClone>>,
          TError,
          Awaited<ReturnType<typeof currentClone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentClone<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current connected site for a URL.
 */

export function useCurrentClone<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentCloneQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentCloneSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentCloneQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentClone>>> = ({ signal }) => currentClone({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentCloneSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof currentClone>>>
export type CurrentCloneSuspenseQueryError = ErrorType<void>


export function useCurrentCloneSuspense<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentCloneSuspense<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentCloneSuspense<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current connected site for a URL.
 */

export function useCurrentCloneSuspense<TData = Awaited<ReturnType<typeof currentClone>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentClone>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentCloneSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSwitchSubscriptionUrl = () => {




  return `/api/Sites/switchSubscription`
}

/**
 * Switches the subscription for a number of times.
 * @summary Switches the subscription for a number of times.
 */
export const switchSubscription = async (transferSiteDto: TransferSiteDto, options?: RequestInit): Promise<number> => {

  return customFetch<number>(getSwitchSubscriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferSiteDto)
  }
);}




export const getSwitchSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchSubscription>>, TError,{data: TransferSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof switchSubscription>>, TError,{data: TransferSiteDto}, TContext> => {

const mutationKey = ['switchSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchSubscription>>, {data: TransferSiteDto}> = (props) => {
          const {data} = props ?? {};

          return  switchSubscription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof switchSubscription>>>
    export type SwitchSubscriptionMutationBody = TransferSiteDto
    export type SwitchSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Switches the subscription for a number of times.
 */
export const useSwitchSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchSubscription>>, TError,{data: TransferSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchSubscription>>,
        TError,
        {data: TransferSiteDto},
        TContext
      > => {
      return useMutation(getSwitchSubscriptionMutationOptions(options), queryClient);
    }
    export const getSwitchSubscriptionNumberOfTimesUrl = () => {




  return `/api/Sites/switchSubscriptionNumberOfTimes`
}

/**
 * Switches the subscription for a number of times.
 * @summary Switches the subscription for a number of times.
 */
export const switchSubscriptionNumberOfTimes = async (switchSubscriptionNumberOfTimesDto: SwitchSubscriptionNumberOfTimesDto, options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getSwitchSubscriptionNumberOfTimesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(switchSubscriptionNumberOfTimesDto)
  }
);}




export const getSwitchSubscriptionNumberOfTimesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchSubscriptionNumberOfTimes>>, TError,{data: SwitchSubscriptionNumberOfTimesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof switchSubscriptionNumberOfTimes>>, TError,{data: SwitchSubscriptionNumberOfTimesDto}, TContext> => {

const mutationKey = ['switchSubscriptionNumberOfTimes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchSubscriptionNumberOfTimes>>, {data: SwitchSubscriptionNumberOfTimesDto}> = (props) => {
          const {data} = props ?? {};

          return  switchSubscriptionNumberOfTimes(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchSubscriptionNumberOfTimesMutationResult = NonNullable<Awaited<ReturnType<typeof switchSubscriptionNumberOfTimes>>>
    export type SwitchSubscriptionNumberOfTimesMutationBody = SwitchSubscriptionNumberOfTimesDto
    export type SwitchSubscriptionNumberOfTimesMutationError = ErrorType<void>

    /**
 * @summary Switches the subscription for a number of times.
 */
export const useSwitchSubscriptionNumberOfTimes = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchSubscriptionNumberOfTimes>>, TError,{data: SwitchSubscriptionNumberOfTimesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchSubscriptionNumberOfTimes>>,
        TError,
        {data: SwitchSubscriptionNumberOfTimesDto},
        TContext
      > => {
      return useMutation(getSwitchSubscriptionNumberOfTimesMutationOptions(options), queryClient);
    }
    export const getGetManyPagedSitesUrl = (params?: GetManyPagedSitesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Sites/paged?${stringifiedParams}` : `/api/Sites/paged`
}

/**
 * Get and filter sites
 * @summary Get sites
 */
export const getManyPagedSites = async (params?: GetManyPagedSitesParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetManyPagedSitesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyPagedSitesQueryKey = (params?: GetManyPagedSitesParams,) => {
    return [
    `/api/Sites/paged`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyPagedSitesQueryOptions = <TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(params?: GetManyPagedSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyPagedSitesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyPagedSites>>> = ({ signal }) => getManyPagedSites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyPagedSitesQueryResult = NonNullable<Awaited<ReturnType<typeof getManyPagedSites>>>
export type GetManyPagedSitesQueryError = ErrorType<void>


export function useGetManyPagedSites<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params: undefined |  GetManyPagedSitesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyPagedSites>>,
          TError,
          Awaited<ReturnType<typeof getManyPagedSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedSites<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params?: GetManyPagedSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyPagedSites>>,
          TError,
          Awaited<ReturnType<typeof getManyPagedSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedSites<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params?: GetManyPagedSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sites
 */

export function useGetManyPagedSites<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params?: GetManyPagedSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyPagedSitesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyPagedSitesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(params?: GetManyPagedSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyPagedSitesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyPagedSites>>> = ({ signal }) => getManyPagedSites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyPagedSitesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyPagedSites>>>
export type GetManyPagedSitesSuspenseQueryError = ErrorType<void>


export function useGetManyPagedSitesSuspense<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params: undefined |  GetManyPagedSitesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedSitesSuspense<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params?: GetManyPagedSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedSitesSuspense<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params?: GetManyPagedSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sites
 */

export function useGetManyPagedSitesSuspense<TData = Awaited<ReturnType<typeof getManyPagedSites>>, TError = ErrorType<void>>(
 params?: GetManyPagedSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyPagedSitesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneSiteUrl = (id: string,
    params?: GetOneSiteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Sites/${id}?${stringifiedParams}` : `/api/Sites/${id}`
}

/**
 * Get a single site
 * @summary Get a site
 */
export const getOneSite = async (id: string,
    params?: GetOneSiteParams, options?: RequestInit): Promise<Site> => {

  return customFetch<Site>(getGetOneSiteUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOneSiteQueryKey = (id: string,
    params?: GetOneSiteParams,) => {
    return [
    `/api/Sites/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOneSiteQueryOptions = <TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneSiteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneSite>>> = ({ signal }) => getOneSite(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneSiteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneSite>>>
export type GetOneSiteQueryError = ErrorType<void>


export function useGetOneSite<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetOneSiteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneSite>>,
          TError,
          Awaited<ReturnType<typeof getOneSite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneSite<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneSite>>,
          TError,
          Awaited<ReturnType<typeof getOneSite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneSite<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a site
 */

export function useGetOneSite<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneSiteQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneSiteSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneSiteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneSite>>> = ({ signal }) => getOneSite(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneSiteSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOneSite>>>
export type GetOneSiteSuspenseQueryError = ErrorType<void>


export function useGetOneSiteSuspense<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params: undefined |  GetOneSiteParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneSiteSuspense<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneSiteSuspense<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a site
 */

export function useGetOneSiteSuspense<TData = Awaited<ReturnType<typeof getOneSite>>, TError = ErrorType<void>>(
 id: string,
    params?: GetOneSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneSiteSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getUpdateOneSiteUrl = (id: string,) => {




  return `/api/Sites/${id}`
}

export const updateOneSite = async (id: string,
    updateSiteDto: UpdateSiteDto, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOneSiteUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSiteDto)
  }
);}




export const getUpdateOneSiteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneSite>>, TError,{id: string;data: UpdateSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneSite>>, TError,{id: string;data: UpdateSiteDto}, TContext> => {

const mutationKey = ['updateOneSite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneSite>>, {id: string;data: UpdateSiteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneSite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOneSiteMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneSite>>>
    export type UpdateOneSiteMutationBody = UpdateSiteDto
    export type UpdateOneSiteMutationError = ErrorType<void>

    export const useUpdateOneSite = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneSite>>, TError,{id: string;data: UpdateSiteDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOneSite>>,
        TError,
        {id: string;data: UpdateSiteDto},
        TContext
      > => {
      return useMutation(getUpdateOneSiteMutationOptions(options), queryClient);
    }
    export const getDeleteOneSiteUrl = (id: string,) => {




  return `/api/Sites/${id}`
}

export const deleteOneSite = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteOneSiteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteOneSiteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneSite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneSite>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteOneSite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneSite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneSite(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOneSiteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneSite>>>

    export type DeleteOneSiteMutationError = ErrorType<void>

    export const useDeleteOneSite = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneSite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOneSite>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteOneSiteMutationOptions(options), queryClient);
    }
    export const getGetManySitesUrl = (params?: GetManySitesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Sites?${stringifiedParams}` : `/api/Sites`
}

/**
 * Get and filter sites
 * @summary Get sites
 */
export const getManySites = async (params?: GetManySitesParams, options?: RequestInit): Promise<Site[]> => {

  return customFetch<Site[]>(getGetManySitesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManySitesQueryKey = (params?: GetManySitesParams,) => {
    return [
    `/api/Sites`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManySitesQueryOptions = <TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(params?: GetManySitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManySitesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManySites>>> = ({ signal }) => getManySites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManySitesQueryResult = NonNullable<Awaited<ReturnType<typeof getManySites>>>
export type GetManySitesQueryError = ErrorType<void>


export function useGetManySites<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params: undefined |  GetManySitesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManySites>>,
          TError,
          Awaited<ReturnType<typeof getManySites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManySites<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params?: GetManySitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManySites>>,
          TError,
          Awaited<ReturnType<typeof getManySites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManySites<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params?: GetManySitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sites
 */

export function useGetManySites<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params?: GetManySitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManySitesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManySitesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(params?: GetManySitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManySitesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManySites>>> = ({ signal }) => getManySites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManySitesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManySites>>>
export type GetManySitesSuspenseQueryError = ErrorType<void>


export function useGetManySitesSuspense<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params: undefined |  GetManySitesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManySitesSuspense<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params?: GetManySitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManySitesSuspense<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params?: GetManySitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sites
 */

export function useGetManySitesSuspense<TData = Awaited<ReturnType<typeof getManySites>>, TError = ErrorType<void>>(
 params?: GetManySitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManySites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManySitesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getUpdateSiteUrlUrl = (id: string,) => {




  return `/api/Sites/${id}/url`
}

export const updateSiteUrl = async (id: string,
    updateSiteUrlDto: UpdateSiteUrlDto, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateSiteUrlUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSiteUrlDto)
  }
);}




export const getUpdateSiteUrlMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteUrl>>, TError,{id: string;data: UpdateSiteUrlDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSiteUrl>>, TError,{id: string;data: UpdateSiteUrlDto}, TContext> => {

const mutationKey = ['updateSiteUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSiteUrl>>, {id: string;data: UpdateSiteUrlDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSiteUrl(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSiteUrlMutationResult = NonNullable<Awaited<ReturnType<typeof updateSiteUrl>>>
    export type UpdateSiteUrlMutationBody = UpdateSiteUrlDto
    export type UpdateSiteUrlMutationError = ErrorType<void>

    export const useUpdateSiteUrl = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSiteUrl>>, TError,{id: string;data: UpdateSiteUrlDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSiteUrl>>,
        TError,
        {id: string;data: UpdateSiteUrlDto},
        TContext
      > => {
      return useMutation(getUpdateSiteUrlMutationOptions(options), queryClient);
    }
